<template>
  <div class="content">
    <div class="wrapper">
      <div class="filters">
        <evaluationFilter ref="evaluationFilter" :filters="filters" :type="'multi'" :date="dateConfig" @getFilters="getFilters" />
        <div class="btn greenBtn srBtn" @click="startSearch">
          <img src="@assets/img/common/static.svg" alt="static">
          统计搜索
        </div>
        <div class="borderBottom"></div>
      </div>
      <div class="list">
        <div class="handleLine">
          <div class="left">
            <div class="sorts">
              <div :class="{sort: true, active: sortKey == s.key}" v-for="(s, i) in sorts" @click="toggleSort(s)" :key="i">
                <span>{{s.title}}</span>
                <img src="@assets/img/common/up.svg" alt="up" v-if="sortKey === s.key">
              </div>
            </div>
          </div>
          <div class="handles">
            <div class="btn" @click="getList">
              <img src="@assets/img/resources/fresh.svg" alt="fresh">
              刷新
            </div>
            <div class="btn greenBtn ml10" @click="exportRes">
              <img src="@assets/img/resources/export.svg" alt="export">
              导出
            </div>
          </div>
        </div>
        <div class="titleLine">
          <span class="title">报道名称</span>
          <span class="name">播出栏目</span>
          <span class="name">供片</span>
          <span class="name">发布者</span>
          <span class="score">发布日期</span>
          <span class="score">播出日期</span>
          <span class="res">得分</span>
        </div>
        <empty :mTop="50" v-if="list.length === 0" :msg="'暂无统计数据'" />
        <div v-for="(l, i) in list" :key="i">
          <div class="item">
            <span class="grayBg"></span>
            <div class="inner">
              <div :class="{title: true, ft16: true, sec: true}" @click="goReport(l.report_id)">
                <span>{{l.report_title}}</span>
              </div>
              <div class="name sec">
                <div v-for="(c, ci) in l.column_list" :key="ci">
                  {{c.column_title}}
                </div>
              </div>
              <div class="name sec">{{l.depart_title}}</div>
              <div class="name sec">{{l.user_name}}</div>
              <div class="score sec timeFont">{{l.report_release_time}}</div>
              <div class="score sec timeFont">
                <div v-for="(t, ti) in l.raw_update_time" :key="ti">{{t}}</div>
              </div>
              <div class="res sec">
                <div class="resItem" v-for="(r, d) in l.result" :key="d">
                  <div class="name">{{r.type}}</div>
                  <div class="score">{{r.name}}</div>
                  <div class="name gradeFont">{{r.app_res}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
      </div>
    </div>
  </div>
</template>

<script>
import evaluationFilter from '@components/evaluationFilter';
import common from '@common/common';
import pages from '@components/pages';
import { apis } from '@common/config';
import empty from '@components/empty';

export default {
  name: 'departStatic',
  components: {
    evaluationFilter, pages, empty
  },
  data() {
    return {
      isXnew: this.$store.state.isXnew,
      filters: [],
      dateConfig: {
        title: '发布时间',
        type: 'date',
        range: true,
        placer: ' 开始时间 ～ 结束时间'
      },
      filterOptions: {},
      searchOptions: {},
      page: {
        pageSize: 20,
        pageIndex: 1,
        page_count: 0,
        total: 0
      },
      list: [],
      sorts: [
        {
          title: '发布时间',
          key: 'create'
        }, {
          title: '播出时间',
          key: 'release_time'
        }
      ],
      sortKey: ''
    }
  },
  mounted() {
    this.sorts = this.sorts
    this.sortKey = this.sorts[0].key

    this.getList()
  },
  methods: {
    toggleSort(s) {
      // 切换排序
      if (this.sortKey === s.key) {
        return
      }

      this.sortKey = s.key
      this.getList()
    },
    startSearch() {
      // 统计搜索
      this.getList()
    },
    getFilters(f) {
      // 接收filters
      this.page.pageIndex = 1
      this.filterOptions = f
    },
    getList() {
      const id = this.$route.params.id
      const info = {
        idstring: id,
        depart_id: '',
        appraisal_type: '',
        score: '',
        level: '',
        start: '',
        end: '',
        search_option: '',
        key_words: '',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        order_by: this.sortKey
      }

      this.searchOptions.key_words = this.$store.state.keyWord

      Object.assign(info, this.filterOptions, this.searchOptions)

      common.myFetch(apis.departStatic, info)
        .then((data) => {
          if (data) {
            this.list = data.list
            this.generateFilters(data.params.list_search)
            this.generateSearchs(data.params.top_search.option.list)
            this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
            this.$set(this.page, 'total', data.page.row_count - 0)
          }
        })
    },
    generateFilters(data) {
      // 整理过滤条件数据
      this.filters.forEach((i) => {
        data.forEach((j) => {
          if (i.key === j.key) {
            j.expand = !!i.expand
          }

          if (i.list) {
            i.list.forEach((c) => {
              j.list && j.list.forEach((d) => {
                if (c.key === d.key) {
                  d.expand = !!c.expand
                }
              })
            })
          }
        })
      })

      const filters = data.filter((i) => {
        return i.key !== 'start' && i.key !== 'end'
      })

      this.filters = filters
    },
    generateSearchs(data) {
      // 整理搜索栏数据
      const types = data.map((i) => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        }
      })

      const filterData = {
        types: types,
        callback: (o) => {
          this.getSearch(o)
        }
      }
      this.postSearch(filterData)
    },
    postSearch(data) {
      // 发送搜索框数据
      this.$emit('filterData', data)
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d
      this.getList()
    },
    exportRes() {
      // 导出
      const info = {
        depart_id: '',
        appraisal_type: '',
        score: '',
        level: '',
        start: '',
        end: '',
        search_option: '',
        key_words: '',
        order_by: this.sortKey
      }
      const userKeys = common.userKeys()
      const params = Object.assign({}, info, userKeys, this.filterOptions, this.searchOptions)
      const url = apis.departStaticExport

      common.exportRes(url, params)
    },
    getYesterday() {
      const today = +new Date()
      const yesterday = today - 24 * 60 * 60 * 1000

      return new Date(yesterday)
    },
    goReport(id) {
      // 跳转报道详情
      common.jump(`/reportDetail?d=${id}`, true)
    }
  }
}
</script>

<style lang="less" scoped src="@assets/css/evaluation/static.less"></style>